const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-year',
        "label": '연도',
        "value": 'year',
        "query": {'y': 'year'},
        "options": {
          default: new Date().getFullYear()
        }
      },
      {
        'component': 'search-check-group',
        "label": '',
        "value": 'half',
        "query": {'ck_l': 'checkList'},
        "options": {
          list: [{text: '상반기', value: '상반기'}, {text: '하반기', value: '하반기'}],
          selectMaxCount: 1,
          default: [],
        }
      },
      {'component': 'empty-space'},
      {
        'component': 'search-start-end',
        "label": '작성일',
        "value": 'date',
        "query": {'ss': 'startDate', 'ee': 'endDate'},
        "options": {
          default: {sd: '', ed: ''},
        }
      },
      {
        'component': 'search-column-keyword',
        "label": '검색조건',
        "value": 'column',
        "query": {'ck_t': 'head', 'ck_k': 'keyword'},
        "options": {hiddenList: ['구분', '소관부서', '작성일']}
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    if (search.year) {
      conditions.push({key: 'header.year', operator: '=', value: search.year})
    }

    // 상반기 / 하반기
    if (search.half && search.half.length > 0) {
      conditions.push({key: 'body.구분', operator: '=', value: search.half[0]})
    }

    //  검색일
    if (search.date) {
      conditions.push({key: 'created_at', operator: '>=', value: search.date.startDate})
      conditions.push({key: 'created_at', operator: '<', value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : ''})
    }

    //  재해형태
    if (search.disaster) {
      conditions.push({key: 'body.disasterList[%]', operator: 'LIKE', value: `%${search.disaster}%`})
    }

    //  검색조건
    const heads = list.getHead().map(e => { return {[e.name] : e.key} });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      { name: '연도', key: 'header.year' },
      { name: '시설명', key: 'body.fields[%].field_name', style: {maxWidth: '350px', whiteSpace: 'normal', wordBreak: 'break-all'} },
      { name: '구분', key: 'body.구분'},
      { name: '소관부서', key: 'body.소관부서', style: {maxWidth: '350px'} },
      { name: '작성자', key: 'body.stdInfo.writer_name' },
      { name: '작성일', key: 'created_at' },
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: {
        try {
          const content = JSON.parse(value.post_content);
          return content && content.header ? content.header.year : '';
        } catch (e) {
          return '';
        }
      }
      case 1: return func.getContent(value).fields.map(field => field.field_name).join(", ")
      case 2: {
        return func.getContent(value).구분 || '';
      }
      case 3: {
        const body = func.getContent(value)
        if (body.fields && body.fields.length > 0) {
          const 소관부서 = body.fields.map((item) => {
            const meta = item.meta ? JSON.parse(item.meta) : {};
            return meta.소관부서;
          });
          return [...new Set(소관부서)].join(', ')
        }
        return ""
      }
      case 4: return func.getContent(value).stdInfo.writer_name // 작성자
      case 5: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/
    }
    return ''
  },

  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
}

export default list;
